import type { SortableItemModel } from "@octopusdeploy/design-system-components";
import { SortableList } from "@octopusdeploy/design-system-components";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent/DataBaseComponent";
import SaveDialogLayout from "~/components/DialogLayout/SaveDialogLayout";
interface StepSortModel extends SortableItemModel {
    Id: string;
}
interface StepSorterProps {
    title: string;
    initialItems: StepSortModel[];
    stepId?: string;
    onComplete(ordered: StepSortModel[]): void;
}
interface StepSorterState extends DataBaseComponentState {
    items: StepSortModel[];
}
class StepSorter extends DataBaseComponent<StepSorterProps, StepSorterState> {
    constructor(props: StepSorterProps) {
        super(props);
        this.state = {
            items: [...this.props.initialItems],
        };
    }
    async save() {
        if (this.state.items) {
            this.props.onComplete(this.state.items);
        }
        return true;
    }
    render() {
        const steps = this.state.items;
        return (<SaveDialogLayout title={this.props.title} busy={this.state.busy} errors={this.errors} onSaveClick={() => this.save()} saveButtonLabel="Done">
                {steps && <SortableList onItemsUpdated={this.stepsOrderChanged} items={this.state.items}/>}
            </SaveDialogLayout>);
    }
    private stepsOrderChanged = (items: StepSortModel[]) => {
        this.setState({ items });
    };
    static displayName = "StepSorter";
}
export default StepSorter;
